import { render, staticRenderFns } from "./GoodsSelector.vue?vue&type=template&id=f0c37012&scoped=true"
import script from "./GoodsSelector.vue?vue&type=script&lang=js"
export * from "./GoodsSelector.vue?vue&type=script&lang=js"
import style0 from "./GoodsSelector.vue?vue&type=style&index=0&id=f0c37012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c37012",
  null
  
)

export default component.exports